import React from 'react';
import { Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

const FilterButtons = ({ options = [], selectedValue, onChange, sx, buttonSx }) => {
  return (
    <Box sx={{ mb: { xs: 2, sm: 2.5, md: 3.5 }, display: 'flex', gap: { xs: 1, sm: 1.25, md: 1.5 }, flexWrap: 'wrap', ...sx }}>
      {options.map((option) => {
        const value = typeof option === 'string' ? option : option.value;
        const label = typeof option === 'string' ? option : option.label;
        const isActive = selectedValue === value;

        return (
          <Button
            key={value}
            onClick={() => onChange(value)}
            variant={isActive ? 'contained' : 'outlined'}
            sx={{
              textTransform: 'none',
              borderRadius: '43px',
              px: { xs: 2, sm: 2.5, md: 3 },
              py: { xs: 0.75, sm: 1, md: 1 },
              fontFamily: 'IBM Plex Sans, sans-serif',
              fontWeight: 500,
              fontStyle: 'normal',
              fontSize: { xs: '0.7rem', sm: '0.9375rem', md: '1rem' },
              lineHeight: 1.5,
              letterSpacing: '0%',
              ...(isActive
                ? {
                    bgcolor: '#0F172A',
                    color: '#FFFFFF',
                    '&:hover': {
                      bgcolor: '#0F172A',
                    },
                  }
                : {
                    border: '1px solid #0F172A',
                    color: '#0F172A',
                    '&:hover': {
                      borderColor: '#0F172A',
                      bgcolor: 'transparent',
                    },
                  }),
              ...buttonSx,
            }}
          >
            {label}
          </Button>
        );
      })}
    </Box>
  );
};

FilterButtons.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.string.isRequired,
      }),
    ])
  ).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.object,
  buttonSx: PropTypes.object,
};

export default FilterButtons;
